import React, { useContext, useEffect, useState } from 'react';
import { Card, Row, Col, Badge, Button } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import { FaUser, FaEnvelope, FaIdCard, FaUserShield, FaCheckCircle, FaEdit } from 'react-icons/fa';
import { normalizeRole } from '../utils/rbac';

const Profile = () => {
  const { user } = useContext(AuthContext);
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    if (user) {
      setProfileData({
        fullName: user.full_name || '—',
        username: user.username || '—',
        email: user.email || '—',
        role: user.role || '—',
        id: user.id || '—',
        isActive: user.is_active !== false
      });
    }
  }, [user]);

  const getRoleLabel = (role) => {
    const normalizedRole = normalizeRole(role);
    const labels = {
      admin: 'مدير النظام',
      supervisor: 'مشرف',
      technician: 'فني',
      branch: 'مستخدم فرع'
    };
    return labels[normalizedRole] || normalizedRole;
  };

  const getRoleBadgeVariant = (role) => {
    const normalizedRole = normalizeRole(role);
    const variants = {
      admin: 'danger',
      supervisor: 'warning',
      technician: 'primary',
      branch: 'secondary'
    };
    return variants[normalizedRole] || 'secondary';
  };

  if (!profileData) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-muted">جاري تحميل البيانات...</div>
      </div>
    );
  }

  return (
    <div className="page-container profile-page">
      <Row className="g-4">
        <Col md={12}>
          <Card className="shadow-sm">
            <Card.Header className="bg-white py-3">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0">
                  <FaUser className="ms-2" />
                  ملفي الشخصي
                </h5>
                <Badge bg={getRoleBadgeVariant(profileData.role)}>
                  {getRoleLabel(profileData.role)}
                </Badge>
              </div>
            </Card.Header>
            <Card.Body>
              <Row className="gy-4">
                <Col md={6}>
                  <div className="profile-info-item">
                    <div className="profile-info-label">
                      <FaUser className="ms-2 text-muted" />
                      الاسم الكامل
                    </div>
                    <div className="profile-info-value">{profileData.fullName}</div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="profile-info-item">
                    <div className="profile-info-label">
                      <FaIdCard className="ms-2 text-muted" />
                      اسم المستخدم
                    </div>
                    <div className="profile-info-value">@{profileData.username}</div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="profile-info-item">
                    <div className="profile-info-label">
                      <FaEnvelope className="ms-2 text-muted" />
                      البريد الإلكتروني
                    </div>
                    <div className="profile-info-value">
                      {profileData.email !== '—' ? profileData.email : 'غير متوفر'}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="profile-info-item">
                    <div className="profile-info-label">
                      <FaUserShield className="ms-2 text-muted" />
                      الدور / الصلاحية
                    </div>
                    <div className="profile-info-value">
                      <Badge bg={getRoleBadgeVariant(profileData.role)}>
                        {getRoleLabel(profileData.role)}
                      </Badge>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="profile-info-item">
                    <div className="profile-info-label">
                      <FaIdCard className="ms-2 text-muted" />
                      رقم المستخدم (ID)
                    </div>
                    <div className="profile-info-value">#{profileData.id}</div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="profile-info-item">
                    <div className="profile-info-label">
                      <FaCheckCircle className="ms-2 text-muted" />
                      حالة الحساب
                    </div>
                    <div className="profile-info-value">
                      <Badge bg={profileData.isActive ? 'success' : 'secondary'}>
                        {profileData.isActive ? 'نشط' : 'غير نشط'}
                      </Badge>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Profile;
